import { useContext } from "react";
import ToastsContext from "~/contexts/ToastsContext";

export default function useToasts() {
  return useContext(ToastsContext);
}
